export enum RequestAccessTrigger {
  Submit = 'submit',
  Accept = 'accept',
  Reject = 'reject',
  EditComment = 'edit_comment',
}
